<template>
  <div>
    <a-card :title="pageTitle" style="margin: 20px">
      <template #extra>
        <a-button @click="goBack">返回</a-button>
      </template>

      <!-- 表单区域 -->
      <div class="formBox">
        <a-form-model
            ref="feeRuleForm"
            :colon="false"
            :label-col="{ span: 4 }"
            :model="formData"
            :rules="formRules"
            :wrapper-col="{ span: 14 }"
            label-align="left"
        >
          <a-form-model-item label="规则编号" prop="feeNo">
            <a-input
                v-model.trim="formData.feeNo"
                :disabled="isEdit"
                allow-clear
                class="short-input"
                placeholder="请输入规则编号"
            />
          </a-form-model-item>

          <a-form-model-item label="规则名称" prop="feeName">
            <a-input
                v-model.trim="formData.feeName"
                allow-clear
                class="short-input"
                placeholder="请输入规则名称"
            />
          </a-form-model-item>

          <a-form-model-item label="规则类型" prop="feeType">
            <a-select
                v-model="formData.feeType"
                class="short-input"
                placeholder="请选择规则类型"
                @change="onFeeTypeChange"
            >
              <a-select-option value="1">定额</a-select-option>
              <a-select-option value="2">按比例</a-select-option>
              <a-select-option value="3">分段</a-select-option>
              <a-select-option value="4">按比例按天</a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 定额 -->
          <template v-if="formData.feeType === '1'">
            <a-form-model-item label="定额费用" prop="fixedFee">
              <a-input-number
                  v-model="formData.fixedFee"
                  :min="0"
                  :precision="2"
                  class="short-input"
                  placeholder="请输入定额费用"
              />
            </a-form-model-item>
          </template>

          <!-- 按比例 -->
          <template v-if="formData.feeType === '2'">
            <a-form-model-item label="比例" prop="feeProportion">
              <a-input-number
                  v-model="formData.feeProportion"
                  :min="0"
                  :max="1"
                  :step="0.001"
                  :precision="4"
                  class="short-input"
                  placeholder="如 0.005 表示 0.5%"
              />
              <span style="margin-left: 8px; color: #999;">
                {{ formData.feeProportion != null ? (formData.feeProportion * 100) + '%' : '' }}
              </span>
            </a-form-model-item>
            <a-form-model-item label="费用下限">
              <a-input-number
                  v-model="formData.feeMin"
                  :min="0"
                  :precision="2"
                  class="short-input"
                  placeholder="最低费用（可为空）"
              />
            </a-form-model-item>
            <a-form-model-item label="费用上限">
              <a-input-number
                  v-model="formData.feeMax"
                  :min="0"
                  :precision="2"
                  class="short-input"
                  placeholder="最高费用（可为空）"
              />
            </a-form-model-item>
          </template>

          <!-- 按比例按天 -->
          <template v-if="formData.feeType === '4'">
            <a-form-model-item label="日比例" prop="feeProportion">
              <a-input-number
                  v-model="formData.feeProportion"
                  :min="0"
                  :max="1"
                  :step="0.001"
                  :precision="4"
                  class="short-input"
                  placeholder="每日比例"
              />
              <span style="margin-left: 8px; color: #999;">
                {{ formData.feeProportion != null ? (formData.feeProportion * 100) + '%/天' : '' }}
              </span>
            </a-form-model-item>
          </template>

          <!-- 备注 -->
          <a-form-model-item label="备注">
            <a-textarea
                v-model="formData.note"
                :rows="3"
                class="short-input"
                placeholder="备注信息（可选）"
            />
          </a-form-model-item>

          <!-- 分段规则区域 -->
          <template v-if="formData.feeType === '3'">
            <a-form-model-item label="分段规则">
              <a-alert
                  type="info"
                  show-icon
                  message="设置多个金额区间（大于X ~ 小于等于Y），每个区间可单独设置定额费用或按比例收费。金额区间不能重叠。"
                  style="margin-bottom: 12px;"
              />
              <a-table
                  :columns="fdRuleColumns"
                  :data-source="formData.feeFdRules"
                  :pagination="false"
                  :row-key="(record, index) => index"
                  bordered
                  size="small"
                  table-layout="fixed"
              >
                <template slot="index" slot-scope="text, record, index">
                  {{ index + 1 }}
                </template>
                <template slot="fdFeeType" slot-scope="text, record, index">
                  <a-select
                      v-model="record.feeType"
                      placeholder="请选择"
                      style="width: 100%"
                      @change="() => onFdRuleChange(index)"
                  >
                    <a-select-option value="11">定额分段</a-select-option>
                    <a-select-option value="21">按比例分段</a-select-option>
                  </a-select>
                </template>
                <template slot="amountMin" slot-scope="text, record, index">
                  <a-input-number
                      v-model="record.tradeAmountMin"
                      :min="0"
                      :precision="2"
                      placeholder="大于"
                      style="width: 100%"
                  />
                </template>
                <template slot="amountMax" slot-scope="text, record, index">
                  <a-input-number
                      v-model="record.tradeAmountMax"
                      :min="0"
                      :precision="2"
                      placeholder="小于等于"
                      style="width: 100%"
                  />
                </template>
                <template slot="fixedFee" slot-scope="text, record, index">
                  <a-input-number
                      v-if="record.feeType === '11'"
                      v-model="record.fixedFee"
                      :min="0"
                      :precision="2"
                      placeholder="定额费用"
                      style="width: 100%"
                  />
                  <span v-else style="color: #ccc">-</span>
                </template>
                <template slot="proportion" slot-scope="text, record, index">
                  <template v-if="record.feeType === '21'">
                    <a-input-number
                        v-model="record.feeProportion"
                        :min="0"
                        :max="1"
                        :step="0.001"
                        :precision="4"
                        placeholder="比例"
                        style="width: 100%"
                    />
                    <div style="margin-top: 2px;">
                      <a-input-number
                          v-model="record.feeMin"
                          :min="0"
                          :precision="2"
                          placeholder="下限"
                          style="width: 48%"
                          size="small"
                      />
                      <a-input-number
                          v-model="record.feeMax"
                          :min="0"
                          :precision="2"
                          placeholder="上限"
                          style="width: 48%; margin-left: 2%;"
                          size="small"
                      />
                    </div>
                  </template>
                  <span v-else style="color: #ccc">-</span>
                </template>
                <template slot="note" slot-scope="text, record, index">
                  <a-input
                      v-model="record.note"
                      placeholder="备注"
                      size="small"
                      style="width: 100%"
                  />
                </template>
                <template slot="action" slot-scope="text, record, index">
                  <a-button
                      icon="delete"
                      style="color: #ff4d4f;"
                      type="link"
                      @click="removeFdRule(index)"
                  >删除</a-button>
                </template>
              </a-table>
              <div style="margin-top: 8px;">
                <a-button icon="plus" style="width: 100%;" type="dashed" @click="addFdRule">新增分段规则</a-button>
              </div>
            </a-form-model-item>
          </template>

          <!-- 按钮区域 -->
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button @click="goBack">取消</a-button>
            <a-button :loading="confirmLoading" style="margin-left: 8px;" type="primary" @click="handleSave">
              {{ isEdit ? '保存' : '新增' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  name: 'FeeRuleDetail',
  data() {
    return {
      mode: 'add',
      formData: {
        id: null,
        feeNo: '',
        feeName: '',
        feeType: undefined,
        fixedFee: null,
        feeProportion: null,
        feeMax: null,
        feeMin: null,
        note: '',
        feeFdRules: [],
      },
      formRules: {
        feeNo: [{required: true, message: '请输入规则编号', trigger: 'blur'}],
        feeName: [{required: true, message: '请输入规则名称', trigger: 'blur'}],
        feeType: [{required: true, message: '请选择规则类型', trigger: 'change'}],
        fixedFee: [{required: true, message: '请输入定额费用', trigger: 'blur'}],
        feeProportion: [{required: true, message: '请输入比例', trigger: 'blur'}],
      },
      fdRuleColumns: [
        {title: '序号', dataIndex: 'index', width: 50, align: 'center', scopedSlots: {customRender: 'index'}},
        {title: '分段类型', dataIndex: 'feeType', width: 120, scopedSlots: {customRender: 'fdFeeType'}},
        {title: '金额起始(大于)', dataIndex: 'tradeAmountMin', width: 120, scopedSlots: {customRender: 'amountMin'}},
        {title: '金额截止(≤)', dataIndex: 'tradeAmountMax', width: 120, scopedSlots: {customRender: 'amountMax'}},
        {title: '定额费用', dataIndex: 'fixedFee', width: 120, scopedSlots: {customRender: 'fixedFee'}},
        {title: '比例(下限/上限)', dataIndex: 'proportion', width: 180, scopedSlots: {customRender: 'proportion'}},
        {title: '备注', dataIndex: 'note', width: 120, scopedSlots: {customRender: 'note'}},
        {title: '操作', key: 'action', width: 80, scopedSlots: {customRender: 'action'}},
      ],
      confirmLoading: false,
    };
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    },
    isAdd() {
      return this.mode === 'add';
    },
    pageTitle() {
      const map = {add: '新增手续费规则', edit: '编辑手续费规则'};
      return map[this.mode] || '手续费规则';
    },
  },
  mounted() {
    this.mode = this.$route.query.mode || 'add';
    if (this.$route.query.id) {
      this.formData.id = this.$route.query.id;
      this.loadDetail();
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await this.api.feeRuleDetailsApi(this.formData.id);
        if (res.code === 200 && res.data) {
          this.formData = {
            ...res.data,
            feeFdRules: res.data.feeFdRules || [],
          };
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    onFeeTypeChange() {
      // 切换规则类型时清空不相关字段
      this.formData.fixedFee = null;
      this.formData.feeProportion = null;
      this.formData.feeMax = null;
      this.formData.feeMin = null;
      if (this.formData.feeType !== '3') {
        this.formData.feeFdRules = [];
      }
    },

    onFdRuleChange(index) {
      const rule = this.formData.feeFdRules[index];
      if (rule.feeType === '11') {
        rule.feeProportion = null;
        rule.feeMin = null;
        rule.feeMax = null;
      } else if (rule.feeType === '21') {
        rule.fixedFee = null;
      }
    },

    addFdRule() {
      this.formData.feeFdRules.push({
        feeType: undefined,
        tradeAmountMin: null,
        tradeAmountMax: null,
        fixedFee: null,
        feeProportion: null,
        feeMin: null,
        feeMax: null,
        note: '',
      });
    },

    removeFdRule(index) {
      this.formData.feeFdRules.splice(index, 1);
    },

    handleSave() {
      this.$refs.feeRuleForm.validate(async (valid) => {
        if (!valid) return;

        // 校验分段规则
        if (this.formData.feeType === '3') {
          if (!this.formData.feeFdRules || this.formData.feeFdRules.length === 0) {
            message.warning('分段规则类型下，至少需要一条分段规则');
            return;
          }
          for (let i = 0; i < this.formData.feeFdRules.length; i++) {
            const rule = this.formData.feeFdRules[i];
            if (!rule.feeType) {
              message.warning(`第${i + 1}条分段规则：请选择分段类型`);
              return;
            }
            if (rule.tradeAmountMin == null && rule.tradeAmountMax == null) {
              message.warning(`第${i + 1}条分段规则：请设置至少一个金额区间值`);
              return;
            }
            if (rule.feeType === '11' && rule.fixedFee == null) {
              message.warning(`第${i + 1}条分段规则：定额分段请设置定额费用`);
              return;
            }
            if (rule.feeType === '21' && rule.feeProportion == null) {
              message.warning(`第${i + 1}条分段规则：按比例分段请设置比例`);
              return;
            }
          }
        } else {
          // 非分段：校验必填
          if (this.formData.feeType === '1' && this.formData.fixedFee == null) {
            message.warning('定额规则请填写定额费用');
            return;
          }
          if ((this.formData.feeType === '2' || this.formData.feeType === '4') && this.formData.feeProportion == null) {
            message.warning('请填写比例');
            return;
          }
        }

        this.confirmLoading = true;
        try {
          const res = await this.api.feeRuleaddApi(this.formData);
          if (res.code === 200) {
            message.success(this.isAdd ? '新增成功' : '保存成功');
            this.$router.push('/base/feeRule');
          } else {
            message.error(res.info || (this.isAdd ? '新增失败' : '保存失败'));
          }
        } catch (error) {
          console.error("保存失败:", error);
          message.error(this.isAdd ? '新增失败' : '保存失败');
        } finally {
          this.confirmLoading = false;
        }
      });
    },

    goBack() {
      this.$router.push('/base/feeRule');
    },
  },
};
</script>

<style lang="less" scoped>
.formBox {
  padding: 20px;
}

.short-input {
  width: 300px !important;
}

/deep/ .ant-form-item {
  margin-bottom: 16px;
}
</style>
